import {
    Pagination,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableFooter,
    TableHeader,
    WindmillContext,
    TableRow
} from "@windmill/react-ui";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import TransPortLineChart from "components/chart/LineChart/TransportlineChart";
import TransportDoughnutChart from "components/chart/Pie/transportPieCharts";
import ChartCardone from "components/chart/ChartCardone";
import SalesCardItemOne from "components/dashboard/SalesCarditem-one";
import SalesCardItemtwo from "components/dashboard/transportcarditems";
import TableLoading from "components/preloader/TableLoading";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";
import { SidebarContext } from "context/SidebarContext";
import useAsync from "hooks/useAsync";
import useFilter from "hooks/useFilter";
import sidebar from "routes/sidebar";
import DashboardServices from "services/DashboardServices";
import "../dashboardComponents/Accountsalesdashboard.css"
import OverAllBookingimg
    from "../../assets/TransPortManagerdashboardicons/OverAllBookingImg.webp";
import UnallotedvendorImg
    from "../../assets/TransPortManagerdashboardicons/unAllotedvenders.webp";
import UnallotedDriversImg
    from "../../assets/TransPortManagerdashboardicons/UnallotedDrivers.webp";
import CancelledBookingImg
    from "../../assets/TransPortManagerdashboardicons/cancelledBookingImg.webp";
import UnsubmittedBillImg
    from "../../assets/TransPortManagerdashboardicons/UnsubmittedBillImg.webp";
import unverifiedBillImg
    from "../../assets/salesdashboaricons/partiallyreceived.webp";
import UnpaidBillImg
    from "../../assets/salesdashboaricons/receivablesales.webp";
import TotalpaidBill
    from "../../assets/TransPortManagerdashboardicons/totalpaidBillImg.webp";
import { useHistory } from "react-router-dom";


const GRAPHTYPE = {
    week: 1,
    month: 2,
    year: 3,
};


const TransportManagerDashboard = () => {
    const history = useHistory();
    const { globalSetting } = useFilter();
    const { mode } = useContext(WindmillContext);
    const { currentPage, handleChangePage, lang } =
        useContext(SidebarContext);
    const { t } = useTranslation();

    const currency = globalSetting?.default_currency;

    const [view, setView] = useState("month"); // default tab
    const [chartData, setChartData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [percentageChange, setPercentageChange] = useState(0);



    const adminInfo = localStorage.getItem("adminInfo")
        ? JSON.parse(localStorage.getItem("adminInfo"))
        : null;
    const employeeId = adminInfo?.id
    const {
        data: TransPortData,
        loading: loadingtransportData,
        error,
    } = useAsync(() => DashboardServices.getProfileDashboard(employeeId));
    useEffect(() => {
        // console.log("Loading:", loadingtransportData);
        // console.log("Data:", TransPortData);
    }, [loadingtransportData, TransPortData]);

    const formatDateDMY = (iso) => {
        if (!iso) return "-";
        return new Date(iso).toLocaleDateString("en-GB", {
            timeZone: "UTC",
        });
    };


    useEffect(() => {
        const fetchPurchaseGraph = async () => {
            try {
                setLoading(true);

                const type = GRAPHTYPE[view];

                const res = await DashboardServices.getTransportGraph(type, employeeId);
                // console.log("ressssss:", res)


                const transportStats =
                    res?.data?.booking_graph || [];

                const percentage =
                    res?.data?.percentage_change || 0;

                const normalizedData = transportStats.map((item) => ({
                    label: item.label,
                    total: Number(item.booking_count) || 0,
                }));

                setChartData(normalizedData);
                setPercentageChange(Number(percentage));
            } catch (error) {
                console.error("Purchase graph API error:", error);
                setChartData([]);
            } finally {
                setLoading(false);
            }
        };

        fetchPurchaseGraph();
    }, [view, employeeId]);




    return (
        <>
            <PageTitle sidebar={sidebar().sidebar} />
            <h1
                style={{
                    color: "black",
                    fontWeight: 600,
                    fontSize: "20px",
                }}
            >
                Current Month Status
            </h1>

            <div className="grid gap-4 mb-8 md:grid-cols-4">

                <SalesCardItemtwo
                    mode={mode}
                    currency={currency}
                    title2="Overall Bookings"
                    Img={OverAllBookingimg}
                    price={TransPortData?.data?.counts?.current_month_bookings_count || 0}
                    className="bg-white text-black"
                    loading={loadingtransportData}
                    onNavigation='/bookings'
                    current_month={true}
                    type={false}
                />
                <SalesCardItemtwo
                    mode={mode}
                    currency={currency}
                    title2="Unalloted Vendors"
                    Img={UnallotedvendorImg}
                    price={TransPortData?.data?.counts?.unalloted_vendors_count || 0}
                    className="bg-white text-black"
                    loading={loadingtransportData}
                    onNavigation="/vendorallotment"
                    daytitle="+30 Days"
                    passDates={true}
                    type={1}


                />
                <SalesCardItemtwo
                    mode={mode}
                    currency={currency}
                    title2="Unallotted Vehicles"
                    Img={UnallotedDriversImg}
                    price={TransPortData?.data?.counts?.unalloted_vehicle_count || 0}
                    className="bg-white text-black"
                    loading={loadingtransportData}
                    onNavigation='/vehicle-allotment'
                    passDates={true}
                    type={1}
                    daytitle="+30 Days"
                />
                <SalesCardItemtwo
                    mode={mode}
                    currency={currency}
                    title2="Cancelled Bookings"
                    Img={CancelledBookingImg}
                    price={TransPortData?.data?.counts?.cancelled_bookings_count || 0}
                    className="bg-white text-black"
                    loading={loadingtransportData}
                    onNavigation='/bookings'
                    type="8"
                    current_month={true}
                    passDates={false}

                />
            </div>



            <div className="grid gap-4 md:grid-cols-4 ">
                <SalesCardItemOne
                    card_bg_color='#D7FFDE'
                    title="Unsubmitted Bills"
                    Img={UnsubmittedBillImg}
                    quantity={TransPortData?.data?.counts?.unsubmitted_bill_count || 0}
                    onNavigation='/purchasebill'
                    current_month={true}
                    passDates={false}
                />
                <SalesCardItemOne
                    card_bg_color='#FFF3D7'
                    title="Unverified Bills"
                    Img={unverifiedBillImg}
                    quantity={TransPortData?.data?.counts?.unverified_bill_count || 0}
                    onNavigation="/purchasebill"
                    type="2"
                    current_month={true}
                    passDates={false}
                />
                <SalesCardItemOne
                    card_bg_color='#D7DBFF'
                    title="Unpaid Bills"
                    Img={UnpaidBillImg}
                    quantity={TransPortData?.data?.counts?.unpaid_bill_count || 0}
                    onNavigation='/billpaymentreport'
                    current_month={true}
                    passDates={false}
                />
                <SalesCardItemOne
                    card_bg_color='#FED7FF'
                    title="Today Paid Bills"
                    Img={TotalpaidBill}
                    quantity={TransPortData?.data?.counts?.today_paidbill_count || 0}
                    onNavigation='/billpaymentreport'
                    type={2}
                    passDates={true}
                    current_month={false}
                />

            </div>

            <div className="flex flex-wrap justify-between my-8 w-full ">
                <ChartCardone
                    cardsize='60'
                    mode={mode}
                    loading={loadingtransportData}
                
                >
                    <TransPortLineChart percentageChange={percentageChange}
                        view={view}
                        onViewChange={setView}
                        data={chartData}
                        loading={loading} />
                </ChartCardone>

                <ChartCardone
                    cardsize='38'
                    mode={mode}
                    loading={loadingtransportData}
                  
                >
                    <TransportDoughnutChart salesReport={TransPortData} />
                </ChartCardone>
            </div>

            <h1 className="font-bold mb-2 " style={{ fontSize: "24px" }}>
                Recent Bookings
            </h1>
            {loadingtransportData ? (
                <TableLoading row={5} col={7} />
            ) : TransPortData?.data?.counts?.current_month_bookings_orders?.length > 0 ? (
                <TableContainer className="mb-5">
                    <Table>
                        <TableHeader className="text-center">
                            <tr className="text-sm">
                                <TableCell >Sl.No.</TableCell>
                                <TableCell>Booking Id</TableCell>
                                <TableCell >Guest Name</TableCell>
                                <TableCell>Travel Date</TableCell>
                                <TableCell>Vehicle Type</TableCell>
                                <TableCell>Vendor Name</TableCell>
                            </tr>
                        </TableHeader>

                        <TableBody>
                            {TransPortData?.data?.counts?.current_month_bookings_orders?.map((row, index) => (

                                <TableRow key={index} className="text-center">
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell >
                                        <div className="pt-2 text-blue-400">
                                            <span className="text-sm">{row.ref_no || '-'}</span>
                                        </div>
                                    </TableCell>
                                    <TableCell>{row.client_name}</TableCell>

                                    <TableCell className="text-center">
                                        {row.start_date && row.end_date ? (
                                            <>
                                                <div>{formatDateDMY(row.start_date || '-')}</div>
                                                <div className="pt-3">{formatDateDMY(row.end_date || '-')}</div>
                                            </>
                                        ) : (
                                            "-"
                                        )}
                                    </TableCell>
                                    <TableCell>{row.vehicle_type || '-'}</TableCell>
                                    <TableCell>{row.company || '-'}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            ) : (
                <NotFound title="No recent bookings found" />
            )}

        </>
    );
};

export default TransportManagerDashboard;